import React from 'react'
import { useLocation } from 'react-router-dom'

import IndexDefaultComponent, { formikValuesToApiConvertor } from './indexDefaultComponent'
import { Helmet } from 'react-helmet'
import { META } from '../../constants/meta'

import { getLangFromPath } from '../../i18next'
import { fetchIndexContributions } from '../../store/contributions/contributionsSlice'
import { fetchAdv } from '../../store/adv/advSlice'
import { changeDefaultPageScrolledPagesAmountAndPosition } from '../../store/common/commonSlice'
import isEmpty from 'lodash/isEmpty'
import moment from 'moment-mini'
import '../app.sass'

const initialValues = {
    material: 2,
    gender: 1,
    certified: 0,
    free: 0,
    dateFrom: '2003/09/30',
    dateTo: moment().format('YYYY/MM/DD'),
    periodToSend: moment().subtract(1, 'years').format('YYYY/MM/DD') + '-' + moment().format('YYYY/MM/DD'),
    period: 0,
    limit: 10
}

const IndexVideoFemAndCouple = (): JSX.Element => {
    const location = useLocation()

    return (
        <>
            <IndexDefaultComponent newInitialValues={initialValues} title={'Female and couple videos'} />
            <Helmet>
                <title>{META.indexVideoFemAndCouple[getLangFromPath(location.pathname)].title}</title>
                <meta
                    name="description"
                    content={META.indexVideoFemAndCouple[getLangFromPath(location.pathname)].description}
                />
            </Helmet>
        </>
    )
}

// @ts-ignore
IndexVideoFemAndCouple.getInitialProps = async ({ store, req }) => {
    const {
        common: { scrolledPagesAmountAndPosition },
        contributions: { list }
    } = store.getState()
    if (req) {
        const page = req.query.p

        if (isEmpty(list)) {
            await store.dispatch(fetchIndexContributions(formikValuesToApiConvertor(initialValues, page || 1)))
        }
        if (scrolledPagesAmountAndPosition.sourcePage != 'indexScrolling')
            store.dispatch(changeDefaultPageScrolledPagesAmountAndPosition())
    } else {
        if (isEmpty(list)) {
            await store.dispatch(fetchIndexContributions(formikValuesToApiConvertor(initialValues, 1)))
        }
    }
    await store.dispatch(fetchAdv())
}

export default IndexVideoFemAndCouple
